import React from "react";
import CompanyList from "./CompanyList";

const Corporate = () => {
  return (
    <div className="content-wrappers">
      <div className="content-header">
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col">
                <CompanyList />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Corporate;
